// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { deleteShipTo as deleteShipToApi } from "@ces/App/Services/CustomersService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { UpdateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<UpdateShipToApiParameter & HasOnError & HasOnSuccess, ShipToModel>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await deleteShipToApi(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error);
    }
};

export const DispatchShipTosReset: HandlerType = props => {
    props.dispatch({
        type: "Data/ShipTos/ResetDataViews",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, SendDataToApi, DispatchShipTosReset, ExecuteOnSuccessCallback];

const deleteShipTo = createHandlerChainRunner(chain, "DeleteShipTo");
export default deleteShipTo;
